module.exports=function(scope){ return `<div class="asseco-directmessaging-window-content">
    ${scope.fSubject}
    ${scope.fTitle}
    ${scope.fMsg}
</div>`};